import { AlertTriangle, CheckCircle2 } from "lucide-react";
import { Badge } from "@/components/ui/badge";
import { TONE } from "./emailTokens";

/** Healthy/unhealthy pill used by every email sub-section header. */
export const StateBadge = ({ state, testId }) => (
  <Badge
    variant="outline"
    data-testid={testId}
    className={`gap-1.5 font-normal ${state.healthy ? TONE.ok : TONE.warn}`}
  >
    {state.healthy ? (
      <CheckCircle2 className="h-3 w-3" aria-hidden="true" />
    ) : (
      <AlertTriangle className="h-3 w-3" aria-hidden="true" />
    )}
    {state.label}
  </Badge>
);
